// Phase 3 slice H — capability 3 ("Share items with members of an
// organization.") is gone. Slice B lifted the same-org gate on
// canShareItem, so org membership no longer controls sharing at all.
// The gap in the numeric ids is intentional: existing OrganisationsHistory
// rows and any external references to capability id 3 keep resolving.
export const ORGANISATION_OWNERSHIP_CAPABILITIES = {
    1: {
        category: 1,
        desc: 'organisations.modal.organisation.ownership.capability.1',
    },
    2: {
        category: 2,
        desc: 'organisations.modal.organisation.ownership.capability.2',
    },
    4: {
        category: 4,
        desc: 'organisations.modal.organisation.ownership.capability.4',
    },
    5: {
        category: 5,
        desc: 'organisations.modal.organisation.ownership.capability.5',
    },
    // Phase 3 slice N — admins can transfer ownership of items
    // in the org, even ones they don't own themselves (the
    // offboarding path). Enforced server-side by transferItem
    // Ownership; owner-only sharing still holds.
    6: {
        category: 6,
        desc: 'organisations.modal.organisation.ownership.capability.6',
    },
};
// Category 3 ("Items") is removed alongside capability 3 (see above).
export const ORGANISATION_OWNERSHIP_CAPABILITY_CATEGORIES = {
    1: {
        name: 'Organisation details',
    },
    2: {
        name: 'Member Invitations',
    },
    4: {
        name: 'Member details',
    },
    6: {
        name: 'Item ownership',
    },
};
// Phase 3 slice H — Member is now a bare-seat identifier with no
// capabilities. Admin loses capability 3 (share items) since that's
// no longer gated by org role — canShareItem is owner-only after
// slice B. Admin still owns org-level operations (details, invites,
// member management, deletion).
export const ORGANISATION_OWNERSHIP_TYPES = {
    admin: {
        id: 'admin',
        name: 'organisation.ownership.administrator.text',
        capabilities: [1, 2, 4, 5, 6],
    },
    member: {
        id: 'member',
        name: 'organisation.ownership.member.text',
        capabilities: [],
    },
};
export const ORGANISATION_OWNERSHIP_OPTIONS = Object.keys(ORGANISATION_OWNERSHIP_TYPES).map((ownershipId) => ({
    label: ORGANISATION_OWNERSHIP_TYPES[ownershipId].name,
    value: ORGANISATION_OWNERSHIP_TYPES[ownershipId].id,
}));
export const ORGANISATION_OWNERSHIP_CAPABILITY_LOOKUP = Object.keys(ORGANISATION_OWNERSHIP_TYPES).reduce((all, current) => {
    const capabilityDescs = ORGANISATION_OWNERSHIP_TYPES[current].capabilities.map((capabilityId) => ORGANISATION_OWNERSHIP_CAPABILITIES[capabilityId].desc);
    return {
        ...all,
        [current]: capabilityDescs,
    };
}, { admin: [], member: [] });
//# sourceMappingURL=organisation-ownership.js.map